import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatTabsModule } from "@angular/material/tabs";
import { MatCardModule } from "@angular/material/card";
import { MatBadgeModule } from "@angular/material/badge";
import { DistrictAdminComponent } from "./components/districtadmin.component";
import { TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DropdownModule } from "primeng/dropdown";
import { MultiSelectModule } from "primeng/multiselect";
import { DialogModule } from "primeng/dialog";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { ColorPickerModule } from "primeng/colorpicker";
import { ConfirmationService } from "primeng/api";
import { InputNumberModule } from "primeng/inputnumber";
import { ListboxModule } from "primeng/listbox";

import { DataService_scanstationtracking } from "./scanstationtracking/shared/data.service";

import { DistrictContactInfoComponent } from "./districtcontactinfo/districtcontactinfo.component";
import { EmailMaintenanceComponent } from "./emailmaintenance/emailmaintenance.component";
import { EditEmailComponent } from "./emailmaintenance/editemail/editemail.component";
import { AddEmailComponent } from "./emailmaintenance/addemail/addemail.component";

import { ScanStationTrackingComponent } from "./scanstationtracking/scanstationtracking.component";
import { DistrictsettingsComponent } from "./districtsettings/districtsettings.component";
import { DistrictCalendarComponent } from "./districtcalendar/district-calendar.component";
import { CalendarEntryComponent } from "./districtcalendar/calendar-entry/calendar-entry.component";
import { SecuritySettingsComponent } from "./security-settings/security-settings.component";
import { DistrictSchoolMaintenanceComponent } from "./district-school-maintenance/district-school-maintenance.component";
import { DistrictEditSchoolComponent } from "./district-school-maintenance/district-edit-school/district-edit-school.component";
import { DistrictAddSchoolComponent } from "./district-school-maintenance/district-add-school/district-add-school.component";
import { FacilityAssignComponent } from "./district-school-maintenance/shared/facility-assign/facility-assign.component";
import { DistrictSchoolAddFacilityComponent } from "./district-school-maintenance/shared/facility-assign/district-school-add-facility/district-school-add-facility.component";

import { FacilitySetupComponent } from "./facility-setup/facility-setup.component";
import { DistrictAddFacilityComponent } from "./facility-setup/district-add-facility/district-add-facility.component";
import { DistrictEditFacilityComponent } from "./facility-setup/district-edit-facility/district-edit-facility.component";
import { DataService_FacilitySetup } from "./facility-setup/shared/data.service";
import { SiteadminFacilityNameComponent } from "./facility-setup/shared/siteadmin-facility-name/siteadmin-facility-name.component";
import { SiteadminFacilityLocationsComponent } from "./facility-setup/shared/siteadmin-facility-locations/siteadmin-facility-locations.component";
import { SiteadminFacilitySchoolsComponent } from "./facility-setup/shared/siteadmin-facility-schools/siteadmin-facility-schools.component";
import { SiteadminFacilityScanStationComponent } from "./facility-setup/shared/siteadmin-facility-scan-station/siteadmin-facility-scan-station.component";
import { SiteadminFacilityVisitorPassComponent } from "./facility-setup/shared/siteadmin-facility-visitor-pass/siteadmin-facility-visitor-pass.component";
import { FacilityAddLocationComponent } from "./facility-setup/shared/siteadmin-facility-locations/facility-add-location/facility-add-location.component";
import { FacilityEditLocationComponent } from "./facility-setup/shared/siteadmin-facility-locations/facility-edit-location/facility-edit-location.component";
import { FacilityAddSchoolComponent } from "./facility-setup/shared/siteadmin-facility-schools/facility-add-school/facility-add-school.component";
import { SystemClockComponent } from "./system-clock/system-clock.component";
import { ApplicationProcessComponent } from "./application-process/application-process.component";
import { AddScheduledJobComponent } from "./application-process/add-scheduled-job/add-scheduled-job.component";
import { EditScheduledJobComponent } from "./application-process/edit-scheduled-job/edit-scheduled-job.component";
import { ApplicationHistoryInfoComponent } from "./application-process/application-history-info/application-history-info.component";
import { ViewApplicationRunLogComponent } from "./application-process/application-history-info/view-application-run-log/view-application-run-log.component";
import { RunAdHocComponent } from "./application-process/run-ad-hoc/run-ad-hoc.component";
import { DistrictZeroAccountsComponent } from "./district-zero-accounts/district-zero-accounts.component";
import { DZAAddSchoolComponent } from "./district-zero-accounts/dza-add-school/dza-add-school.component";

import { SchoolTypeSetupComponent } from "./school-type-setup/school-type-setup.component";
import { DistrictAddSchoolTypeComponent } from "./school-type-setup/district-add-school-type/district-add-school-type.component";
import { DistrictEditSchoolTypeComponent } from "./school-type-setup/district-edit-school-type/district-edit-school-type.component";
import { DataService_SchoolTypeSetup } from "./school-type-setup/shared/data.service";

import { GradeLevelSetupComponent } from "./grade-level-setup/grade-level-setup.component";
import { DistrictEditGradeLevelComponent } from "./grade-level-setup/district-edit-grade-level/district-edit-grade-level.component";
import { DataService_GradeLevelSetup } from "./grade-level-setup/shared/data.service";

import { DriverVerifyActivationComponent } from "../siteadmin/driver-verify-activation/driver-verify-activation.component";
import { DriverVerifyAuthorizedDriversComponent } from "./driver-verify-authorized-drivers/driver-verify-authorized-drivers.component";
import { DataService_AuthorizedDrivers } from "./driver-verify-authorized-drivers/shared/data.service";
import { AddAuthorizedDriverComponent } from "./driver-verify-authorized-drivers/add-authorized-driver/add-authorized-driver.component";
import { EditAuthorizedDriverComponent } from "./driver-verify-authorized-drivers/edit-authorized-driver/edit-authorized-driver.component";
import { DataService_DriverVerifyActivation } from "../siteadmin/driver-verify-activation/shared/data.service";
import { AddDVActivationComponent } from "../siteadmin/driver-verify-activation/add-dvactivation/add-dvactivation.component";
import { EditDVActivationComponent } from "../siteadmin/driver-verify-activation/edit-dvactivation/edit-dvactivation.component";
import { EmailDVActivationComponent } from "../siteadmin/driver-verify-activation/email-dvactivation/email-dvactivation.component";
import { ImportAuthorizedDriverComponent } from "./driver-verify-authorized-drivers/import-authorized-driver/import-authorized-driver.component";
import { DriverVerifyLogComponent } from "./driver-verify-log/driver-verify-log.component";
import { DataService_VerifyLog } from "./driver-verify-log/shared/data.service";
import { ViewDriverVerifyLogDetailsComponent } from "./driver-verify-log/view-driver-verify-log-details/view-driver-verify-log-details.component";
import { DistrictAdministrationService } from "./services/districtadministration.service";
import { MealSubsidyTypeMaintenanceComponent } from "./meal-subsidy-type-maintenance/meal-subsidy-type-maintenance.component";
import { DataService_MealSubsidyType } from "./meal-subsidy-type-maintenance/shared/data.service";
import { DistrictModifyMealSubsidyComponent } from "./meal-subsidy-type-maintenance/district-modify-meal-subsidy/district-modify-meal-subsidy.component";
import { DigitalIdActivationsComponent } from "./digital-id-activations/digital-id-activations.component";
import { DigitalIdModifyActivationComponent } from "./digital-id-activations/digital-id-modify-activation/digital-id-modify-activation.component";
import { DataService_DigitalIDActivations } from "./digital-id-activations/shared/data.service";
import { DigitalIdAddActivationComponent } from "./digital-id-activations/digital-id-add-activation/digital-id-add-activation.component";
import { DIdAddSchoolsComponent } from "./digital-id-activations/digital-id-add-activation/did-add-schools/did-add-schools.component";
import { DigitalIdDebugQrCodeComponent } from "./digital-id-activations/digital-id-debug-qr-code/digital-id-debug-qr-code.component";
import { SiteadminFacilityMsVisitorPassComponent } from "./facility-setup/shared/siteadmin-facility-ms-visitor-pass/siteadmin-facility-ms-visitor-pass.component";
import { DistrictAddSchoolConfirmIDComponent } from "./district-school-maintenance/district-add-school/district-add-school-confirm-id/district-add-school-confirm-id.component";
import { ScanStationTrackingSUComponent } from "./scan-station-tracking-su/scan-station-tracking-su.component";
import { DataService_ScanStationTrackingSU } from "./scan-station-tracking-su/shared/data.service";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { ScanStationSuUpdateAllComponent } from "./scan-station-tracking-su/scan-station-su-update-all/scan-station-su-update-all.component";
import { ScanStationRebuildSUComponent } from "./scan-station-rebuild-su/scan-station-rebuild-su.component";
import { DataService_ScanStationRebuildSU } from "./scan-station-rebuild-su/shared/data.service";
import { DistrictCalendarMainViewComponent } from "./districtcalendar/district-calendar-main-view/district-calendar-main-view.component";
import { DistrictCalendarHolidayViewComponent } from "./districtcalendar/district-calendar-holiday-view/district-calendar-holiday-view.component";
import { DistrictAddHolidayComponent } from "./districtcalendar/district-calendar-holiday-view/district-add-holiday/district-add-holiday.component";
import { DistrictImportHolidayComponent } from "./districtcalendar/district-calendar-holiday-view/district-import-holiday/district-import-holiday.component";
import { DistrictCalendarSchoolTableComponent } from "./districtcalendar/district-calendar-holiday-view/shared/district-calendar-school-table/district-calendar-school-table.component";
import { CalendarImportColumnTableComponent } from './districtcalendar/district-calendar-holiday-view/district-import-holiday/calendar-import-column-table/calendar-import-column-table.component';

const material = [MatButtonModule, MatButtonToggleModule, MatCardModule, MatTabsModule];
@NgModule({
	declarations: [
		DistrictAdminComponent,
		DistrictContactInfoComponent,
		EmailMaintenanceComponent,
		EditEmailComponent,
		AddEmailComponent,
		ScanStationTrackingComponent,
		DistrictsettingsComponent,
		DistrictCalendarComponent,
		CalendarEntryComponent,
		SecuritySettingsComponent,
		DistrictSchoolMaintenanceComponent,
		DistrictEditSchoolComponent,
		DistrictAddSchoolComponent,
		FacilityAssignComponent,
		DistrictSchoolAddFacilityComponent,
		FacilitySetupComponent,
		DistrictAddFacilityComponent,
		DistrictEditFacilityComponent,
		SiteadminFacilityNameComponent,
		SiteadminFacilityLocationsComponent,
		SiteadminFacilitySchoolsComponent,
		SiteadminFacilityScanStationComponent,
		SiteadminFacilityVisitorPassComponent,
		FacilityAddLocationComponent,
		FacilityEditLocationComponent,
		FacilityAddSchoolComponent,
		SystemClockComponent,
		ApplicationProcessComponent,
		AddScheduledJobComponent,
		EditScheduledJobComponent,
		ApplicationHistoryInfoComponent,
		ViewApplicationRunLogComponent,
		RunAdHocComponent,
		DistrictZeroAccountsComponent,
		DZAAddSchoolComponent,
		SchoolTypeSetupComponent,
		DistrictAddSchoolTypeComponent,
		DistrictEditSchoolTypeComponent,
		GradeLevelSetupComponent,
		DistrictEditGradeLevelComponent,
		DriverVerifyActivationComponent,
		DriverVerifyAuthorizedDriversComponent,
		AddAuthorizedDriverComponent,
		EditAuthorizedDriverComponent,
		AddDVActivationComponent,
		EditDVActivationComponent,
		EmailDVActivationComponent,
		ImportAuthorizedDriverComponent,
		DriverVerifyLogComponent,
		ViewDriverVerifyLogDetailsComponent,
		MealSubsidyTypeMaintenanceComponent,
		DistrictModifyMealSubsidyComponent,
		DigitalIdActivationsComponent,
		DigitalIdModifyActivationComponent,
		DigitalIdAddActivationComponent,
		DIdAddSchoolsComponent,
		DigitalIdDebugQrCodeComponent,
		SiteadminFacilityMsVisitorPassComponent,
		DistrictAddSchoolConfirmIDComponent,
		ScanStationTrackingSUComponent,
		ScanStationSuUpdateAllComponent,
		ScanStationRebuildSUComponent,
		DistrictCalendarMainViewComponent,
		DistrictCalendarHolidayViewComponent,
		DistrictAddHolidayComponent,
		DistrictImportHolidayComponent,
		DistrictCalendarSchoolTableComponent,
  CalendarImportColumnTableComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		BrowserAnimationsModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		DropdownModule,
		MultiSelectModule,
		PersonSelectorModule,
		TableModule,
		CalendarModule,
		material,
		ColorPickerModule,
		InputNumberModule,
		SchoolselectorModule,
		ListboxModule,
	],
	providers: [
		DistrictAdministrationService,
		DataService_scanstationtracking,
		ConfirmationService,
		DataService_FacilitySetup,
		DataService_SchoolTypeSetup,
		DataService_GradeLevelSetup,
		DataService_AuthorizedDrivers,
		DataService_DriverVerifyActivation,
		DataService_VerifyLog,
		DataService_MealSubsidyType,
		DataService_DigitalIDActivations,
		DataService_ScanStationTrackingSU,
		DataService_ScanStationRebuildSU,
	],
})
export class DistrictAdminModule {}
